import { createPlatePlugin } from 'platejs/react';
import { FixedToolbar } from 'src/components/ui/editor/ui/fixed-toolbar';
import { FixedToolbarButtons } from 'src/components/ui/editor/ui/fixed-toolbar-buttons';

export const FixedToolbarKit = [
  createPlatePlugin({
    key: 'fixed-toolbar',
    render: {
      beforeEditable: () => (
        <FixedToolbar className={'toolbar'}>
          <FixedToolbarButtons />
        </FixedToolbar>
      ),
    },
  }),
];
